<template>
  <Tooltip small>
    <p>{{ $t('There are 4 user roles in the Fixtender service') }}:</p>

    <p>
      <strong>{{ $t('Owner') }}</strong> –
      {{ $t("the main administrator of your company's account") }}.
    </p>

    <p>
      <strong>{{ $t('Admin') }}</strong> –
      {{
        $t(
          `has access to all projects of your company and can edit settings. There can be several administrators.`
        )
      }}'
    </p>

    <p>
      <strong>{{ $t('Regular') }}</strong> –
      {{ $t(`has access only to the projects to which he/she was invited.`) }}
    </p>

    <p>
      <strong>{{ $t('Invited') }}</strong> –
      {{ $t('a new user who has not yet accepted the invitation.') }}
    </p>
  </Tooltip>
</template>

<script>
  import Tooltip from '@/components/ui/InfoTooltip';

  export default {
    name: 'RolesTooltip',
    components: {
      Tooltip,
    },
  };
</script>
